import React from 'react';
import { Col, Row } from 'react-bootstrap';

const CrewPlanType = ({ planTypeList, activePlanTypeId, disabled, onSelect, children }) => {
    return (<Row className="plan-type-box">
        {planTypeList.map(item => {
            const planTypeId = item.plan_type_id;
            const url = (activePlanTypeId === planTypeId) ?
                require(`../../../assets/images/plan_active_${planTypeId}.png`) :
                require(`../../../assets/images/plan_${planTypeId}.png`);

            return (<Col key={planTypeId} lg={3} md={3} sm={3} xs={6} style={{ cursor: disabled ? 'default' : 'pointer' }}>
                {disabled ?
                    <img src={url} alt="" /> :
                    <img src={url} alt="" onClick={onSelect.bind(this, planTypeId)} />}
            </Col>)
        }, this)}
        {children}
    </Row>);
}

export default CrewPlanType;